import React from 'react';
import cx from 'classnames';
import {CodeBracketIcon} from '@heroicons/react-v2/24/outline';


import Link from './Link';
import {useAppContext} from '../hooks';

export const BadgeSizes = {
  REGULAR: 'regular',
  LARGE: 'large',
  XLARGE: 'xlarge',
};

const BadgeContent = ({size, color = 'indigo', children}) => (
  <div
    className={cx(`font-semibold inline-block rounded-full py-1 px-2 text-${color} bg-${color}-100`,
      {
        'text-xs': size === BadgeSizes.REGULAR,
        'text-sm': size === BadgeSizes.LARGE,
        'text-base': size === BadgeSizes.XLARGE,
      })}
  >
    {children}
  </div>
);

export const MemberBadge = ({className, size = BadgeSizes.REGULAR, onClick}) => {
  const {hasSubscription} = useAppContext();

  return (
    <span className={className}>
      {hasSubscription ? (
        <BadgeContent size={size}>Member</BadgeContent>
      ) : (
        <Link href="/upgrade" onClick={onClick}>
          <BadgeContent size={size}>Member</BadgeContent>
        </Link>
      )}
    </span>

  );
};

export const CoachBadge = ({
  className, size = BadgeSizes.REGULAR, onClick, coachSlug,
}) => (
  <span className={className}>
    <Link href={`/coach/${coachSlug}`} onClick={onClick}>
      <BadgeContent size={size} color="green">Coach</BadgeContent>
    </Link>
  </span>
);

export const CodingBadge = ({className, size = BadgeSizes.REGULAR}) => (
  <span className={cx('inline-flex items-center', className)}>
    <BadgeContent text="Coding" size={size} color="gray">
      <div className="">
        <CodeBracketIcon className="h-4 w-4 mr-1 stroke-2" />
        IDE
      </div>
    </BadgeContent>
  </span>
);

